import React from 'react';
import ProjectCard from '../components/proiect-united/ProjectCard';

function ProiectUnited() {
  return <ProjectCard />;
}

export default ProiectUnited;